export default "__VITE_ASSET__o_eei89o__"